import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const SELLER_BULLETS = [
  'Any condition — no repairs needed',
  'No agent commissions or hidden fees',
  '7–21 day close on your timeline',
  'We handle title, liens, and back taxes',
];

const BUYER_BULLETS = [
  'Assignable contracts (no MLS competition)',
  'Verified ARVs and rehab scopes',
  'Section-8 and BRRRR-friendly deals',
  'First-look access before public dispo',
];

const BulletList = ({ items, tint }) => (
  <ul className="space-y-2">
    {items.map((b) => (
      <li key={b} className="flex items-start gap-2 text-slate-700">
        <CheckCircle2 className={`w-5 h-5 text-${tint}-600 flex-shrink-0 mt-0.5`} />
        <span>{b}</span>
      </li>
    ))}
  </ul>
);

const MarketSellerBuyerSplit = ({ marketName, sellerCopy, buyerCopy, bg = 'white' }) => (
  <section className={`py-16 bg-${bg}`}>
    <div className="container mx-auto px-6 grid md:grid-cols-2 gap-10 max-w-6xl">
      <div className="p-6 rounded-2xl bg-emerald-50 border border-emerald-100">
        <h2 className="text-2xl font-bold text-slate-900 mb-3">
          Selling a house fast in {marketName}?
        </h2>
        <p className="text-slate-700 leading-relaxed mb-4">{sellerCopy}</p>
        <BulletList items={SELLER_BULLETS} tint="emerald" />
      </div>
      <div className="p-6 rounded-2xl bg-amber-50 border border-amber-100">
        <h2 className="text-2xl font-bold text-slate-900 mb-3">
          Investing in {marketName}?
        </h2>
        <p className="text-slate-700 leading-relaxed mb-4">{buyerCopy}</p>
        <BulletList items={BUYER_BULLETS} tint="amber" />
      </div>
    </div>
  </section>
);

export default MarketSellerBuyerSplit;
